import React from "react"
import {observer} from "mobx-react-lite"
import {UseStores} from "../../hooks/UseStores"
import "./index.scss"
import NestedTable from "../../components/NestedTable"
import {Spinner} from "../../components/Spinner/index"
import InternalError from "../../components/InternalError"

const columns = [
  {
    key: "category",
    label: "Category",
    width: 30,
  },
  {
    key: "brands",
    label: "Brand Name",
    width: 30,
  },
  {
    key: "brandLocations",
    label: "",
    width: 7,
  },
  {
    key: "insights",
    label: "",
    width: 7,
  },

  {
    key: "locations",
    label: "Locations",
    width: 13,
  },
  {
    key: "visits",
    label: "Visits",
    width: 13,
  },
]

const Discovery = function () {
  // Note: top 10 fetching logic is in AppData component
  const {disStore} = UseStores()

  const {tableDataLoading, tableData, tableDataError, selected, expandedRow} =
    disStore.tableStates

  const handleBrandRowClick = (brandId) => {
    disStore.setTableStates({selected: brandId, isBrandSelected: true})
    disStore.setBrandCat(brandId, null)
    disStore.setGeoServiceObj({selected: brandId})
  }

  const handleCategoryRowClick = (sicCode) => {
    const isRowExpanded = expandedRow === sicCode
    let newExpandedRow

    //If a brand is selected and we collapse the category, corresponding category needs to be selected.
    let categoryRow = tableData.find((row) => row.sicCode === expandedRow)
    categoryRow &&
      categoryRow.brands &&
      categoryRow.brands.forEach((brand) => {
        if (selected === brand.id) {
          disStore.setTableStates({selected: categoryRow.sicCode, isBrandSelected: true})
          disStore.setGeoServiceObj({selected: categoryRow.sicCode})
        }
      })
    if (isRowExpanded) {
      newExpandedRow = null //collapse the row if already expanded
    } else {
      newExpandedRow = sicCode
    }
    disStore.setBrandCat(null, sicCode)

    disStore.setTableStates({expandedRow: newExpandedRow})

    if (newExpandedRow) {
      disStore.setTableStates({selected: newExpandedRow})
      //highlight the expanded row
      disStore.setGeoServiceObj({selected: newExpandedRow})
    }
  }

  if (tableDataLoading) return <Spinner />
  if (tableDataError) return <InternalError />

  return (
    <div className="discovery-container">
      {tableData && (
        <NestedTable
          columns={columns}
          data={tableData}
          expandedRow={expandedRow}
          selected={selected}
          handleBrandRowClick={handleBrandRowClick}
          handleCategoryRowClick={handleCategoryRowClick}
        />
      )}
    </div>
  )
}
export default observer(Discovery)
